import { additionalDataDocumentsForm, UseValidationsDocumentFormType } from '../interface'
import { AppContext } from 'context/appContext'
import { FISCAL_FIELDS, LEGAL_FIELDS } from '../../../constants'
import { getFileTypesEntensions } from '../../../helpers'
import { IActivationsPlansFiles } from 'context/interface'
import { IFileItem, IFileTypes } from '../../../interface'
import { useContext, useEffect, useState } from 'react'
import { useFileTypesGet } from 'state/files'
import { useTranslation } from 'react-i18next'
import { validateManualInfoFields, validationField } from '../helpers'
import { ValidationErrors } from 'final-form'

export const useValidationsDocumentsForm = (
  files: Array<IActivationsPlansFiles>,
  hasInternationalDoc: boolean,
  hasKycProblem: boolean,
  additionalData: additionalDataDocumentsForm
): UseValidationsDocumentFormType => {
  const { appStore, wizardData } = useContext(AppContext)
  const { fileTypesGet } = useFileTypesGet()
  const { t } = useTranslation()

  const [fileTypes, setFileTypes] = useState<IFileTypes>({})
  const [fieldsToValidate, setFieldsToValidate] = useState<string[]>([])
  const [fileMaxSizeAllowed, setFileMaxSizeAllowed] = useState(0)

  useEffect(() => {
    const filesToValidate = files.map(({ fileClassificationId }: IActivationsPlansFiles) => fileClassificationId)
    setFieldsToValidate(filesToValidate)
  }, [files])

  useEffect(() => fileTypesGet(), [files])

  useEffect(() => {
    const DATA = appStore.fileTypesGet.data
    if (DATA.length) {
      setFileTypes(getFileTypesEntensions(DATA))
      setFileMaxSizeAllowed(DATA[0]?.maxSize || 0)
    }
  }, [appStore.fileTypesGet.data])

  const handleDocumentsValidation = (values: Record<string, string | IFileItem>): ValidationErrors => {
    const ERRORS: Record<string, string> = {}
    fieldsToValidate.forEach((fileName: string) => {
      validationField(
        values,
        ERRORS,
        fileName,
        files,
        fileTypes,
        fileMaxSizeAllowed,
        hasInternationalDoc,
        t,
        wizardData
      )
    })
    return ERRORS
  }
  const handleManualInfoValidation = (values: Record<string, string | IFileItem>): ValidationErrors => {
    const ERRORS: Record<string, string> = {}
    const infoValidations: string[] = []
    if (additionalData.fiscal) {
      FISCAL_FIELDS.forEach((field: string) => {
        infoValidations.push(field)
      })
    }

    if (additionalData.legal) {
      LEGAL_FIELDS.forEach((field: string) => {
        infoValidations.push(field)
      })
    }
    infoValidations.forEach((field: string) => {
      validateManualInfoFields(values, ERRORS, t, field)
    })
    return ERRORS
  }

  const handleValidation = (values: Record<string, string | IFileItem>): ValidationErrors => {
    if (!hasKycProblem) {
      return handleDocumentsValidation(values)
    }
    return handleManualInfoValidation(values)
  }

  return {
    fieldsToValidate,
    fileMaxSizeAllowed,
    fileTypes,
    handleValidation
  }
}
